import { gql } from 'apollo-boost';

export const COURSE_QUERY = gql`
  query course($courseId: UUID!, $brandId: UUID) {
    course(courseID: $courseId) {
      enrollment {
        status
        rating
        review
        userCertificate(brandId: $brandId) {
          id
          userCertificateUrl
        }
      }
      node {
        id
        courseCertificates {
          id
          brand {
            id
            name
          }
        }
        locales {
          locale
          name
          description
        }
        heroImage {
          id
          url
        }
        thumbnailImage {
          id
          url
        }
        prerequisiteSet {
          operator
          prerequisites {
            objectId
          }
        }
        tags
        ratingAverage
        ratingCount
        isSequential
        learningObjects {
          edges {
            assignment {
              status
              scormState
              startedAt
              completedAt
              timeSpent
            }
            node {
              id
              locales {
                locale
                name
                description
              }
              duration
              format
              content {
                id
                url
                mimetype
              }
            }
          }
        }
        localeIds
        resourceIds
        learningProfileIds
        brandIds
        categoryIds
        metadata
        companyRelationshipIds
        productIds
      }
    }
  }
`;
